export function NotFound() {
  return (
    <>
      <h1 class="recipe__title">Not found</h1>
      <p>
        <a href="/">Back to recipes</a>
      </p>
    </>
  );
}
